import { useParameterizedAsyncData } from "src/utils/async/parameterizedAsyncData.ts";
import { CatalogPartRevisionBomTreeViewApi } from "src/api/generated/erp/parts/catalogPart/api/bom/catalogPartRevisionBomTreeViewApi.ts";
import { AsyncRender } from "src/components/common/async/AsyncRender.tsx";
import { CatalogPartRevisionBomTreeViewResult } from "src/api/generated/erp/parts/catalogPart/api/bom/catalogPartRevisionBomTreeViewResult.ts";
import { PartRevisionBomTreeViewBase } from "src/components/views/erp/parts/treeViews/PartRevisionBomTreeViewBase.tsx";

export interface CatalogPartRevisionBomTreeViewProps {
	catalogPartRevisionId: number;
}

export const CatalogPartRevisionBomTreeView = ({ catalogPartRevisionId }: CatalogPartRevisionBomTreeViewProps) => {
	const { dataAsync, refresh, paramValues } = useParameterizedAsyncData<
		CatalogPartRevisionBomTreeViewResult,
		CatalogPartRevisionBomTreeViewParams
	>({
		fetchData: ({ searchQuery, showRevisions }) =>
			CatalogPartRevisionBomTreeViewApi.getTreeElements({
				catalogPartRevisionId: catalogPartRevisionId,
				searchQuery: searchQuery,
				showRevisions: showRevisions,
			}),
		initialParams: {
			searchQuery: "",
			showRevisions: false,
		},
	});

	return (
		<AsyncRender
			asyncData={dataAsync}
			reloadOnError={() => refresh()}
			content={(data) => (
				<PartRevisionBomTreeViewBase
					treeElements={data.treeElements}
					showRevisions={paramValues.showRevisions}
					onSearchQueryChange={(searchQuery) => refresh({ searchQuery })}
					onShowRevisionsChange={(showRevisions) => refresh({ showRevisions })}
				/>
			)}
		/>
	);
};

interface CatalogPartRevisionBomTreeViewParams {
	searchQuery: string;
	showRevisions: boolean;
}

